import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios, axiosApi } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const apiPostCotizar = async params => {
  const url = typesEndpoint.postCotizar;

  const request = {
    idCotizacion: params.cotizacionID,
    plan: params.idPlan,
    datosPersonales: params.dataPersonal,
    idOportunidad: params.oportunidadID,
    numPlanes: params.numPlanes,
  };

  const config = {
    ...buildRequest(),
    timeout: 0,
  };

  try {
    const { status, data } = await axios.post(url, request, config);

    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};

export const apiPostPlan = async params => {
  const url = typesEndpoint.postPlan;

  const request = {
    plan_id: params.idPlan,
    oportunidadId: params.idOportunidad,
    planesCotizados: params.planesCotizados,
    valorPrimaTotal: params.valorPrimaTotal,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};

export const apiEmitirPoliza = async params => {
  const url = typesEndpoint.emitirPoliza;

  const request = {
    plan: params.plan,
    datosPersonales: params.dataPersonal,
    oportunidadId: params.oportunidadId,
    tokenReCaptcha: params.tokenReCaptcha,
    formaPago: params.formaPago,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());

    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
export const apiRealizarPago = async params => {
  const url = typesEndpoint.realizarPago;

  const request = {
    plan: params.plan,
    datosPersonales: params.dataPersonal,
    dataSeguro: params.dataSeguro,
    dataTarjeta: params.dataTarjeta,
    cotizacion: params.cotizacion,
    seguro: params.seguro,
    formaPago: params.formaPago,
    metodoPago: params.metodoPago,
    oportunidadId: params.oportunidadId,
    tokenReCaptcha: params.tokenReCaptcha,
    numeroIdentidadColegiado: params.numeroIdentidadColegiado,
  };

  try {
    const { status, statusCode, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data, statusCode: status || statusCode });
  } catch (error) {
    return handleError(error);
  }
};

export const apiEnviarResumenCotizacion = async params => {
  const url = typesEndpoint.resumenCorreo;

  const request = {
    id: params.cotizacionId,
  };

  try {
    const { status, data } = await axiosApi.get(url, {
      params: request,
    });
    return dataResponse({ data: data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};

export const apiRecuperarCotizacion = async params => {
  const url = typesEndpoint.recuperarCotizacion;

  const request = {
    idCotizacion: params.cotizacionId,
  };

  try {
    const { status, data } = await axios.get(url, buildRequest(request));
    return dataResponse({ data: data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
